import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}
export const PrintSection = ({ children }: Props) => (
  <div className="p-[10pt] border-b border-b-black">{children}</div>
)
